import { animate, style, transition, trigger } from '@angular/animations';

export const FadeInOut = trigger(
	'fadeInOut', [
		transition(':enter', [
			style({ opacity: 0 }),
			animate('185ms ease-out', style({ opacity: 1 })),
		]),
		transition(':leave', [
			animate('225ms ease-in', style({ opacity: 0 })),
		]),
	]
)

export const FadeOut = trigger(
	'fadeOut', [
		transition(':leave', [
			animate('225ms ease-in', style({ opacity: 0 })),
		]),
	]
)

export const FadeIn = trigger(
	'fadeIn', [
		transition(':enter', [
			style({ opacity: 0 }),
			animate('275ms ease-out', style({ opacity: 1 })),
		]),
	]
)